export const isProd = process.env.NODE_ENV === 'production'
export const isDef = t => t !== undefined
export const isUndef = t => t === undefined
export const isNull = t => t == null
export const Eval = (that, f, ...args) => (f && typeof f === 'function' ? f.apply(that, args) : f)
export const Call = (that, f, ...args) => (f && typeof f === 'function' ? f.apply(that, args) : null)



// WEBPACK FOOTER //
// ./client/src/utils/common.js